import request from '@/utils/request'

export function activityInfoApi (customerKey) {
  return request({
    url: `api/activity/activityInfo/${customerKey}`,
    method: 'get'
  })
}

export function appLoginApi (data) {
  return request({
    url: 'api/activityEmployee/bLogin',
    method: 'post',
    data
  })
}

export function queryCodeApi (code) {
  return request({
    url: `api/activity/queryCode/${code}`,
    method: 'get'
  })
}

export function getOssTokenApi () {
  return request({
    url: '/api/commonFile/getOssToken',
    method: 'get'
  })
}

export function activityCheckoutCodeApi (code) {
  return request({
    url: `api/activityOrder/checkoutCode/${code}`,
    method: 'get'
  })
}

export function integralOrderApi (data) {
  return request({
    url: 'api/activityOrder/integralOrder',
    method: 'post',
    data
  })
}

export function activityEmployeeSendCodeApi (data) {
  return request({
    url: 'api/activityEmployee/sendCode',
    method: 'post',
    data
  })
}

export function activityEmployeeRgisterApi (data) {
  return request({
    url: 'api/activityEmployee/registerEmployee',
    method: 'post',
    data
  })
}

export function activityOrderAppListPageApi (data) {
  return request({
    url: 'api/activityOrder/appListPage',
    method: 'post',
    data
  })
}

export function activityEmployeeInfoApi (employeeId) {
  return request({
    url: `api/activityEmployee/info/${employeeId}`,
    method: 'get'
  })
}

export function activityOrderReceiptOrderApi (data) {
  return request({
    url: 'api/activityOrder/receiptOrder',
    method: 'post',
    data
  })
}

export function activityOrderInfoApi (orderId) {
  return request({
    url: `api/activityOrder/info/${orderId}`,
    method: 'get'
  })
}

export function activityEmployeeQrCodeApi (employeeId) {
  return request({
    url: `api/activityEmployee/qrCode/${employeeId}`,
    method: 'get'
  })
}

export function activityEmployeeSmsLoginApi (data) {
  return request({
    url: 'api/activityEmployee/smsLogin',
    method: 'post',
    data
  })
}

export function activityEmployeeGetByPhoneApi (customerKey, phone) {
  return request({
    url: `api/activityEmployee/getByPhone/${customerKey}?phone=${phone}`,
    method: 'get'
  })
}

export function configLabelListApi () {
  return request({
    url: 'api/config/labelList/1',
    method: 'get'
  })
}

export function activityOrderSnOcrApi (data) {
  return request({
    url: 'api/activityOrder/snOcr',
    method: 'post',
    data
  })
}

export function activityOrderSnOcrResultApi (key) {
  return request({
    url: `api/activityOrder/querySnOcrResult/${key}`,
    method: 'post'
  })
}

export function inviteCreateInviteCodeApi (key) {
  return request({
    url: 'api/invite/createInviteCode',
    method: 'get'
  })
}
